// extracted by mini-css-extract-plugin
export default {"width":"styles_width__b4H8B","body":"styles_body__1N1ss"};